
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45","height":"45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.625 12.019l-2.644-2.644L22.5 19.856 12.019 9.375l-2.644 2.644L19.856 22.5 9.375 32.981l2.644 2.644L22.5 25.144l10.481 10.481 2.644-2.644L25.144 22.5z"}}),_c('path',{attrs:{"d":"M0 0h45v45H0z","fill":"none"}})])
          )
        }
      }
    